import RecordDetail from './RecordDetail';

export default RecordDetail;
